module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "fmtitle"
  }, [_vm._v("List of Illustration")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl1",
      "id": "rpl1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neil Munro "), _c('i', [_vm._v("c")]), _vm._v(". 1907 ("), _c('i', [_vm._v("The Baillie")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl2",
      "id": "rpl2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puffer "), _c('i', [_vm._v("Saxon")]), _vm._v(" (East Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl3",
      "id": "rpl3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TSS "), _c('i', [_vm._v("King Edward")]), _vm._v(" (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl4",
      "id": "rpl4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launch of puffer "), _c('i', [_vm._v("Briton")]), _vm._v(" at Kirkintilloch (East Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl5",
      "id": "rpl5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamers leaving Broomielaw, Glasgow (Editors’ collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl6",
      "id": "rpl6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cargo steamer in Loch Fyne (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl7",
      "id": "rpl7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrochar, Loch Long (West Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl8",
      "id": "rpl8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Among the yachts (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl9",
      "id": "rpl9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kyles of Bute (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl10",
      "id": "rpl10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarbert, Loch Fyne (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl11",
      "id": "rpl11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Campbeltown by sea (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl12",
      "id": "rpl12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carradale, Kintyre (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl13",
      "id": "rpl13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gabbarts at Bowling Harbour (West Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl14",
      "id": "rpl14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gourock Harbour (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl15",
      "id": "rpl15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clyde at Glasgow (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl16",
      "id": "rpl16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inveraray – Neil Munro’s birthplace (Editors’ collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl17",
      "id": "rpl17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PS "), _c('i', [_vm._v("Columba")]), _vm._v(" at Ardrishaig (Editors’ collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl18",
      "id": "rpl18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Take Clynder . . . or any other place in the Gareloch’ ("), _c('i', [_vm._v("Mudges")]), _vm._v(") (Editors’ collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl19",
      "id": "rpl19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘They’re jist at big-gun practice’ ("), _c('i', [_vm._v("Para and the Navy")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl20",
      "id": "rpl20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Where were they bound for? Was’t Kirkintilloch?’ ("), _c('i', [_vm._v("Queer Cargoes")]), _vm._v(") (East Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl21",
      "id": "rpl21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘I’ll bate ye he’s gaun to the Scottish Exhibeetion’ ("), _c('i', [_vm._v("The Stowaway")]), _vm._v(") (Mitchell Library, Glasgow)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl22",
      "id": "rpl22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘I will go over and see my good sister at Helensburgh’ ("), _c('i', [_vm._v("Para Handy, Master Mariner")]), _vm._v(") (West Dunbartonshire Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl23",
      "id": "rpl23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘There’s no much fun in Tobermory in the summer time’ ("), _c('i', [_vm._v("Treasure Trove")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl24",
      "id": "rpl24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The place for life in them days’ ("), _c('i', [_vm._v("Herring: A Gossip")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl25",
      "id": "rpl25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘It was Glasgow Fair Saturday’ ("), _c('i', [_vm._v("Wee Teeny")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl26",
      "id": "rpl26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘A handy wife at the guttin’ ’ ("), _c('i', [_vm._v("Herring: A Gossip")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl27",
      "id": "rpl27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Jack went ashore . . . on an urgent search for milk and butter’ ("), _c('i', [_vm._v("A Rowdy Visitor")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl28",
      "id": "rpl28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brodick Pier and Goat Fell (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl29",
      "id": "rpl29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘High jeenks and big hauls’ ("), _c('i', [_vm._v("Herring: A Gossip")]), _vm._v(") (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl30",
      "id": "rpl30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lochgoilhead (Argyll & Bute Libraries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/122_Plates#pl31",
      "id": "rpl31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pier, Dunoon (Argyll & Bute Libraries)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e85488e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004a_List.vue
// module id = 69
// module chunks = 0